import { render } from "./PopupLocDuLieu.vue?vue&type=template&id=183a07eb"
import script from "./PopupLocDuLieu.vue?vue&type=script&lang=js"
export * from "./PopupLocDuLieu.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__